var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"off-container"},[_c('img',{attrs:{"src":require("@/assets/icon-off.png"),"alt":""}}),_c('div',[_vm._v("视频已下架")])])}]

export { render, staticRenderFns }